import React, { useEffect } from 'react';
import { TooltipPlacement } from 'antd/lib/tooltip';
import { useMatchBenchmarkState } from './hooks';
import ProductMatchInfo from 'src/types/ProductMatcheInfo';
import PopConfirm from 'src/components/common/PopConfirm';

export type BenchmarkMatchButtonProps = {
  matchItems: ProductMatchInfo[] | undefined;
  className?: string;
  tooltipPlacement?: TooltipPlacement;
  onSelectedRow?: () => void;
};

const BenchmarkMatchButton: React.FC<BenchmarkMatchButtonProps> = ({
  matchItems,
  className,
  tooltipPlacement,
  onSelectedRow,
}) => {
  const [{ loading, data, error }, { benchmarkMatch }] = useMatchBenchmarkState();
  const isResponseSuccessful = data && data.statusCode === '200';

  const handleBenchmarkConfirm = () => {
    if (benchmarkMatch && matchItems) {
      benchmarkMatch(matchItems);
    }
    if (isResponseSuccessful && onSelectedRow) {
      onSelectedRow();
    }
  };

  useEffect(() => {
    if (isResponseSuccessful && onSelectedRow) {
      onSelectedRow();
    }
  }, [isResponseSuccessful]);

  return (
    <PopConfirm
      title="Are you sure you want to benchmark this match?"
      onConfirm={handleBenchmarkConfirm}
      icon={['fal', 'bookmark']}
      className={className}
      tooltipPlacement={tooltipPlacement}
      isLoading={loading}
      errorMessage={error.message || error}
    />
  );
};

export default BenchmarkMatchButton;
